import React from 'react';
import * as PropTypes from 'prop-types';
import { Form, Icon, Popup, List } from 'semantic-ui-react';
import UIDGenerator from '../utils/UIDGenerator';
import * as _ from 'lodash';
import FieldToolTip from './FieldToolTip';
import Outlier from './Outlier';
import { mapToOptions } from '../utils/React';
import FieldDescriptionView from './FieldDescriptionView';

const CheckboxGroup = (props) => {
    const {
        label,
        options,
        value = '',
        name,
        onChange,
        disabled = false,
        outputArray = false,
        required,
        editable = true,
        error,
        outlier,
        excludeFromStatistics,
        dataField,
        isManufacturer,
        valueField,
        labelField,
        handleOpenSideBar,
    } = props;
    const u = UIDGenerator.get();

    const values = outputArray ? value || [] : value ? value.split(',') : [];

    const displayValues = values.map(
        (value) =>
            (options || []).find((option) => option.value == value)?.label,
    );

    if (!editable) {
        return (
            <List bulleted>
                {displayValues.map((val, index) => (
                    <List.Item key={index}>{val}</List.Item>
                ))}
            </List>
        );
    }

    const handleOnChange = (event, data) => {
        let newValue = data.checked
            ? [...values, data.value]
            : _.pull(values, data.value);
        if (!outputArray) newValue = newValue.join(',');

        onChange(event, {
            value: newValue,
        });
    };

    const optionsHaveDescription =
        Array.isArray(options) && options?.some((option) => option.description);

    return (
        <Form.Field required={required} error={error}>
            <label>
                {label}
                {!props?.descriptionOnScreen && <FieldToolTip {...props} />}
                {isManufacturer && dataField && (
                    <Outlier
                        value={value}
                        name={name}
                        outlier={outlier}
                        excludeFromStatistics={excludeFromStatistics}
                        onChange={onChange}
                    />
                )}
                {handleOpenSideBar && optionsHaveDescription && (
                    <FieldDescriptionView
                        handleOpenSideBar={handleOpenSideBar}
                    />
                )}
            </label>
            {props?.descriptionOnScreen && props?.description && (
                <div style={{ whiteSpace: 'pre-line' }}>
                    {props.description}
                </div>
            )}
            {_.map(
                mapToOptions(options, labelField, false, valueField),
                (option) => (
                    <Form.Checkbox
                        key={option.key}
                        label={option.text}
                        name={`radioGroup${u}`}
                        value={option.value}
                        checked={values.indexOf(option.value) !== -1}
                        onChange={handleOnChange}
                        disabled={disabled || option.disabled}
                    />
                ),
            )}
        </Form.Field>
    );
};

CheckboxGroup.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onChange: PropTypes.func,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    outputArray: PropTypes.bool,
    required: PropTypes.bool,
    editable: PropTypes.bool,
    dataField: PropTypes.bool,
    outlier: PropTypes.bool,
    excludeFromStatistics: PropTypes.bool,
    isManufacturer: PropTypes.bool,
    descriptionOnScreen: PropTypes.bool,
    valueField: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    labelField: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default CheckboxGroup;
